import { useRouter } from 'next/router';
import { HubSpotContext } from '../hubSpot';

export const useHubSpotContext = (): HubSpotContext => {
  const router = useRouter();
  const currentPageName = document.title;

  return {
    pageName: currentPageName || undefined,
    pageUri: router.asPath || undefined,
  };
};
